/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SnapshotAlarmLogItem = {
  id: number;
  alarm_log_id: number;
  snapshot_id: number;
  analyzer_id: number;
  type: AlarmLogItemType;
  message: string;
  detector_name: string;
};

export enum AlarmLogItemType {
  NORMAL = 0,
  WARNING = 1,
  MONITOR = 2,
  MARKER = 3,
  MASK = 4,
  STOP = 5,
}
